"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = App;
var react_1 = __importStar(require("react"));
var client_1 = __importDefault(require("react-dom/client"));
var chat_window_1 = __importDefault(require("../components/chat-window"));
var transition_overlay_1 = __importDefault(require("../components/transition-overlay"));
var hooks_1 = require("../hooks");
/**
 * Entry point for the direct chat. To keep the data fresh, the chat data is periodically fetched.
 * When a new `chat.last_message` is detected, the first page of messages is refetched.
 */
function App(_a) {
    var _this = this;
    var chatId = _a.chatId, accountId = _a.accountId;
    var REFETCH_INTERVAL = 10000;
    var _b = (0, hooks_1.useEnablingChat)(accountId + "-" + chatId), enabled = _b.enabled, enableOnCurrentWindow = _b.enableOnCurrentWindow;
    var _c = (0, hooks_1.useDirectChat)(chatId, REFETCH_INTERVAL, enabled), dataChat = _c.data, setDataChat = _c.setData, statusChat = _c.status, newMessageCountChat = _c.newMessageCount;
    var _d = (0, hooks_1.useMessages)(chatId), dataMessages = _d.data, setDataMessages = _d.setData, statusMessages = _d.status, hasNextPageMessages = _d.hasNextPage, fetchNextPageMessages = _d.fetchNextPage, refetchFirstPageMessages = _d.refetchFirstPage, isFetchingNextPageMessages = _d.isFetchingNextPage, abortControllerRefMessages = _d.abortControllerRef;
    var _e = (0, hooks_1.useContacts)(), dataContacts = _e.data, statusContacts = _e.status;
    var mutateAddMessage = (0, hooks_1.useAddMessage)().mutate;
    var mutateUpdateMessage = (0, hooks_1.useUpdateMessage)().mutate;
    var mutateUpdateChat = (0, hooks_1.useUpdateChat)().mutate;
    /**
     * Responsible for refetching messages, when `newMessageCountChat` changes.
     */
    (0, react_1.useEffect)(function () {
        if (dataChat === undefined)
            return;
        refetchFirstPageMessages().then(function (messages) {
            return updateReadStatus(dataChat, messages);
        });
    }, [newMessageCountChat]);
    var addMessage = function (chat, message) {
        var _a;
        mutateAddMessage(message);
        (_a = abortControllerRefMessages.current) === null || _a === void 0 ? void 0 : _a.abort();
        setDataMessages(function (prev) { return (prev ? __spreadArray([message], prev, true) : [message]); });
        if (chat.landlord_hide === true) {
            mutateUpdateChat(chat, { landlord_hide: false });
            setDataChat(__assign(__assign({}, chat), { landlord_hide: false }));
        }
    };
    var updateChat = function (chatToUpdate, fieldsToUpdate) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, mutateUpdateChat(chatToUpdate, fieldsToUpdate)];
                case 1:
                    result = _a.sent();
                    if (result)
                        setDataChat(__assign(__assign({}, chatToUpdate), fieldsToUpdate));
                    return [2 /*return*/, result];
            }
        });
    }); };
    var updateHideStatus = function (chatToUpdate, action) {
        var fieldToUpdate = { landlord_hide: action === "hide" };
        mutateUpdateChat(chatToUpdate, fieldToUpdate);
        setDataChat(__assign(__assign({}, chatToUpdate), fieldToUpdate));
    };
    var updateReadStatus = function (chat, messages) {
        var unread = messages.filter(function (m) { return m.sender_type !== chat.user_role && m.read === null; });
        if (unread.length === 0)
            return;
        var newMessages = messages.map(function (m) {
            return unread.includes(m) ? __assign(__assign({}, m), { read: "true" }) : m;
        });
        setDataMessages(newMessages);
        setDataChat(__assign(__assign({}, chat), { last_message: newMessages[newMessages.length - 1] }));
        Promise.all(unread.map(function (message) { return mutateUpdateMessage(message, { read: null }); }));
    };
    if ([statusChat, statusMessages, statusContacts].includes("pending")) {
        return react_1.default.createElement(transition_overlay_1.default, { topic: "chats", icon: "loader" });
    }
    if ([statusChat, statusMessages, statusContacts].includes("error")) {
        return react_1.default.createElement(transition_overlay_1.default, { topic: "errorChats", icon: "close" });
    }
    if (!enabled) {
        return (react_1.default.createElement(transition_overlay_1.default, { topic: "disableChat", children: react_1.default.createElement("div", { className: "w-50 text" },
                react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                        __html: window.Translator.trans("chat.different_tab.headline_direct", {
                            name: (dataChat === null || dataChat === void 0 ? void 0 : dataChat.requests[dataChat.requests.length - 1].name) +
                                " " +
                                (dataChat === null || dataChat === void 0 ? void 0 : dataChat.requests[dataChat.requests.length - 1].surname),
                        }, "js"),
                    } }),
                react_1.default.createElement("button", { onClick: enableOnCurrentWindow, className: "btn btn--primary mt-2" }, window.Translator.trans("chat.different_tab.action", {}, "js"))) }));
    }
    return (dataChat &&
        dataMessages &&
        dataContacts && (react_1.default.createElement(chat_window_1.default, { openChat: dataChat, messages: dataMessages, contacts: dataContacts, addMessage: addMessage, updateChat: updateChat, updateHideStatus: updateHideStatus, hasNextPageMessages: hasNextPageMessages, isFetchingNextPageMessages: isFetchingNextPageMessages, fetchNextPageMessages: fetchNextPageMessages })));
}
var chatDOM = document.getElementById("chat-direct");
if (chatDOM) {
    client_1.default.createRoot(chatDOM).render(react_1.default.createElement(react_1.default.StrictMode, null,
        react_1.default.createElement(App, { chatId: chatDOM.dataset.chatId, accountId: chatDOM.dataset.accountId })));
}
